import { PublisherPaginationSettings } from '../../types/publisherPaginationSettings';
import { ESnapshotExists, ETemplate } from '../../types';
import { mapAsync } from '../../helpers/array/async';
import { wrapError, wrapSuccess } from '../../types/responses';
import { getFillerHeightInPixels } from './aspectRatioHelpers';

export const getFillersForAutoPaginationRequest = async (
  publisherPaginationSettings: ESnapshotExists<PublisherPaginationSettings>,
  template: ESnapshotExists<ETemplate>
) => {
  const { fillers } = publisherPaginationSettings.data();
  const templateStyles = template.data().styles;
  if (!templateStyles) {
    return wrapError(new Error('Template styles not found'));
  }
  return mapAsync(fillers, async filler => {
    const [fillerWithHeightError, fillerWithHeight] =
      await getFillerHeightInPixels(
        filler.pdfUrl,
        filler.columns,
        templateStyles
      );
    if (fillerWithHeightError) {
      return wrapError(fillerWithHeightError);
    }
    return wrapSuccess({
      ...filler,
      height: fillerWithHeight
    });
  });
};
